import ImageFocalPointPicker from '@/components/media/ImageFocalPointPicker'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Focus, RotateCcw } from 'lucide-react'
import { useState } from 'react'

const normalizeCoordinate = (value, fallback = 50) => {
  if (value === null || value === undefined || value === '') return fallback

  const coordinate = Number(value)
  return Number.isFinite(coordinate) ? Math.min(100, Math.max(0, coordinate)) : fallback
}

export const resolveSeasonalFocalPoint = (media, value = {}) => {
  const mediaX = normalizeCoordinate(media?.focal_point_x)
  const mediaY = normalizeCoordinate(media?.focal_point_y)

  return {
    x: normalizeCoordinate(value?.x, mediaX),
    y: normalizeCoordinate(value?.y, mediaY),
  }
}

function SeasonalFocalPointDialogContent({ media, value, onOpenChange, onApply }) {
  const imageDefault = resolveSeasonalFocalPoint(media)
  const [position, setPosition] = useState(() => resolveSeasonalFocalPoint(media, value))

  const apply = () => {
    onApply(position)
    onOpenChange(false)
  }

  return (
    <DialogContent size="xlarge" viewport="scroll">
      <DialogHeader>
        <DialogTitle className="flex items-center gap-2">
          <Focus className="size-5" /> Choose the focal point
        </DialogTitle>
        <DialogDescription>
          Click or drag to the most important part of the arrangement. The storefront will protect
          this area when it crops the banner for wide and mobile screens.
        </DialogDescription>
      </DialogHeader>

      <ImageFocalPointPicker media={media} value={position} onChange={setPosition} />

      <div className="flex justify-end">
        <Button type="button" variant="ghost" onClick={() => setPosition(imageDefault)}>
          <RotateCcw className="size-4" /> Use image focal point
        </Button>
      </div>

      <DialogFooter>
        <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
          Cancel
        </Button>
        <Button type="button" onClick={apply}>
          Apply focal point
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}

export default function SeasonalFocalPointDialog({ open, onOpenChange, media, value, onApply }) {
  return (
    <Dialog open={open && Boolean(media?.url)} onOpenChange={onOpenChange}>
      {open && media?.url ? (
        <SeasonalFocalPointDialogContent
          media={media}
          value={value}
          onOpenChange={onOpenChange}
          onApply={onApply}
        />
      ) : null}
    </Dialog>
  )
}
